import React from "react";
import "./Stopka.css";
export const Stopka = () => {
	return (
		<>
			<div className="stopka">
				<p>Home-Cloud created by AdiBau</p>
				<p>version: 1.1</p>
			</div>
		</>
	);
};
